import React from 'react';

import SectionTitle from '../../components/SectionTitle';
import SingleBlog from '../../components/Blog';

import blogImg1 from '../../assets/img/slider/gemasan-30.svg';
import blogImg2 from '../../assets/img/slider/gemasan-31.svg';
import blogImg3 from '../../assets/img/slider/gemasan-32.svg';

const Blog = () => {
  return (
    <div className="blog__area blog__mlr blog__space">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div
            className="col-xl-7 col-xxl-9 wow animate__fadeInUp"
            data-wow-duration="1.1s"
            data-wow-delay=".3s"
          >
            <SectionTitle
              sectionClass="blog__section-box text-center pb-40 section-title-fixed-width"
              subTitle="Alt Parçalar"
              Title="Deniz Araçları İçin Yerli Tasarım, Yerli Üretim"
            />
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-70 wow animate__fadeInUp"
            data-wow-duration="1.1s"
            data-wow-delay=".5s"
          >
            <SingleBlog
              blogImg={blogImg1}
              blogClass="blog__item"
              titleClass="blog__title blog__title-color-1"
              Title="Su Altı Aydınlatma Sistemi"
              Description="Yerli olarak ürettiğimiz su altı aydınlatma sistemimiz, 300 metre derinliğe kadar sorunsuz bir şekilde çalışabilmektedir. Sistemimiz, su altı operasyonlarında güvenilir ve etkili aydınlatma çözümleri sunmaktadır."
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-70 wow animate__fadeInUp"
            data-wow-duration="1.1s"
            data-wow-delay=".7s"
          >
            <SingleBlog
              blogImg={blogImg2}
              blogClass="blog__item"
              titleClass="blog__title blog__title-color-2"
              Title="Su Altı Kamera Sistemi"
              Description="Su altı kamera sistemimiz yaklaşık 300 metre derinliğe kadar sorunsuz çalışmaktadır. Sistemimiz, 1080p görüntü alma kalitesine sahip olup, su altı operasyonlarında yüksek çözünürlüklü ve net görüntü kaydı sağlamaktadır."
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-70 wow animate__fadeInUp"
            data-wow-duration="1.1s"
            data-wow-delay=".9s"
          >
            <SingleBlog
              blogImg={blogImg3}
              blogClass="blog__item"
              titleClass="blog__title blog__title-color-3"
              Title="Elektronik Kartlar"
              Description={
                <>
                  Üretmiş olduğumuz elektronik kartlar sayesinde insansız su altı ve su üstü araçlarının üretimini çok kolay bir şekilde yerli imkanlarla yapabiliyoruz. Kartlar hakkında detaylı bilgi için{' '}
                  <a 
                    href="https://www.shopier.com/viyalab" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                      color: '#2a3658',
                      fontWeight: '600',
                      fontSize: '1.05em',
                      textDecoration: 'underline',
                      transition: 'color 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#1a2540'}
                    onMouseLeave={(e) => e.target.style.color = '#2a3658'}
                  >
                    viyalab.com
                  </a>
                  {' '}adresi ziyaret edilebilir.
                </>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
